export default {
  width: 12,
  height: 12,
  svg: `
  <path fill="none" fill-rule="nonzero" stroke-linecap="round" stroke-linejoin="round" d="M10.5.5h-9c-.552 0-1 .448-1 1v6c0 .552.448 1 1 1h2v3l3-3h4c.552 0 1-.448 1-1v-6c0-.552-.448-1-1-1z"/>
`,
  stroke: true
}
